import {config} from "@commons/config.instance";
import axios from "axios";
import {addBaseQueryParams, addQueryParams} from "@commons/utils/APIParams";
import {TerminaleRecord} from "@commons/mapping/TerminaleRecord";
import {AziendaParams} from "@commons/services/presenze_api/tabelleAzienda.api";

interface TerminaleParams extends AziendaParams {
    codTerminale: string,
}

export const listTerminali = (params: AziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/azienda/${params.idAziendaTabelle}/terminale?${addQueryParams(queryParams)}`
    return axios<TerminaleRecord[]>(url).then(res => res.data)
}
export const getTerminale = (params: TerminaleParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/azienda/${params.idAziendaTabelle}/terminale/${params.codTerminale}?${addQueryParams(queryParams)}`
    return axios<TerminaleRecord>(url).then(res => res.data)
}